import { render, staticRenderFns } from "./SelectMailTemplate.vue?vue&type=template&id=8f8660ae"
import script from "./SelectMailTemplate.vue?vue&type=script&lang=ts"
export * from "./SelectMailTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports